<template>
	<div>
		<SubscribeMap :items="wards" :api_url="$WARDS_API" v-on:choose="choose" column_name="the_geom"></SubscribeMap>
	</div>
</template>

<script>
	import SubscribeMap from '@/components/SubscribeMap';

	export default {
		props: ['wards'],
		components: { SubscribeMap },
		data() {
			return {
				
			}
		},
		methods: {
			choose(wards) {
				this.$emit('choose',wards);
			}
		}
	}

</script>

<style scoped>

</style>